function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 35px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0;\n  height: 110px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 24px;\n  font-size: 23px;\n  font-weight: 400;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  background: #d3d7dc;\n  ",
        " {\n    height: 4px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  box-shadow: -5px 0px 4px rgb(69 82 96 / 12%);\n  top: 0;\n  bottom: 0;\n  width: 10px;\n  z-index: 11;\n  left: 400px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 10px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  font-weight: bold;\n  line-height: 25px;\n  font-size: 1.1em;\n\n  div {\n    font-weight: bold;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import React, { useRef } from "react";
import propTypes from "prop-types";
import sumBy from "lodash/sumBy";
import uniq from "lodash/uniq";
import setIn from "lodash/set";
import { getAddonDiscount } from "../../../utils/product/getAddonDiscount";
import PercentageBar from "./components/PercentageBar";
import PhaseSummary from "./components/PhaseSummary";
import ChartSection from "./components/ChartSection";
import { getElementWindowTop } from "./utils";
import { calculateItemRowHours } from "../../../modules/phases/utils";
import { Grid, WrRow as Row, WrCol as Col } from "../../grid";
import BackButton from "../../back-button";
import Button from "../../button";
import { Redirect } from "react-router";
import { context, withContext } from "../../wr-context";
import styled from "styled-components";
import * as phasesModule from "../../../modules/phases";
import Card, { CardBody, CardHeader as _CardHeader } from "../../../components/card";
var PageTitle = styled.h1(_templateObject());
var CardHeader = styled(_CardHeader)(_templateObject1());
var CardHeaderLabel = styled.div(_templateObject2());
var TotalPhaseSummary = styled(PhaseSummary)(_templateObject3(), PercentageBar);
var DividerShadow = styled.div(_templateObject4());
var PhaseListContainer = styled.div(_templateObject5());
_GanttView.propTypes = {
    cart: propTypes.array,
    phasesConfig: propTypes.object,
    onSubmit: propTypes.func,
    onBack: propTypes.func
};
function _GanttView(props) {
    var cart = props.cart, tmp = props.phasesConfig, ref = tmp === void 0 ? {} : tmp, _itemGroups = ref.itemGroups, itemGroups = _itemGroups === void 0 ? [] : _itemGroups, onBack = props.onBack, onSubmit = props.onSubmit, isSubmitDisabled = props.isSubmitDisabled, additionalComponents = props.additionalComponents, selectedRegion = props.selectedRegion, gantRef = props.gantRef;
    // Take these from the left section and use them in the right section
    var phaseLabelPositionsRef = useRef([]);
    var allCosts = itemGroups.map(function(group) {
        return group.itemRows.map(function(itemRow) {
            return phasesModule.utils.calculateItemRowCost(itemRow, {
                rateOverrideKey: selectedRegion,
                getDiscount: getAddonDiscount
            }).discountedCost;
        });
    });
    var totalHours = sumBy(itemGroups.map(function(itemGroup) {
        return phasesModule.utils.calculateItemGroupHours(itemGroup);
    }));
    var totalCost = sumBy(allCosts.map(function(itemRowsCosts) {
        return sumBy(itemRowsCosts);
    }));
    if (!cart.length) {
        return /*#__PURE__*/ React.createElement(Redirect, {
            to: context.getRoutePath("index")
        });
    }
    return /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(Row, {
        middle: "xs",
        $gap: "10px"
    }, /*#__PURE__*/ React.createElement(Col, {
        xs: true
    }, /*#__PURE__*/ React.createElement(PageTitle, null, "Gantt Chart")), /*#__PURE__*/ React.createElement(Col, {
        onClick: onBack,
        xs: true,
        $noGrow: true
    }, /*#__PURE__*/ React.createElement(BackButton, null)), /*#__PURE__*/ React.createElement(Col, {
        disabled: isSubmitDisabled,
        onClick: onSubmit,
        xs: true,
        $noGrow: true
    }, /*#__PURE__*/ React.createElement(Button, null, "Submit"))), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("div", {
        ref: gantRef
    }, /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(DividerShadow, null), /*#__PURE__*/ React.createElement(CardHeader, null, /*#__PURE__*/ React.createElement(Row, {
        $noGaps: true
    }, /*#__PURE__*/ React.createElement(Col, {
        xs: true,
        $noGrow: true
    }, /*#__PURE__*/ React.createElement(CardHeaderLabel, {
        style: {
            width: 400
        }
    }, "Phases / Progress")), /*#__PURE__*/ React.createElement(Col, {
        xs: true
    }, /*#__PURE__*/ React.createElement(CardHeaderLabel, null, "Timeline")))), /*#__PURE__*/ React.createElement(CardBody, {
        unpadded: true
    }, /*#__PURE__*/ React.createElement(Row, {
        $noGaps: true
    }, /*#__PURE__*/ React.createElement(Col, {
        xs: true,
        $noGrow: true
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            width: 400
        }
    }, /*#__PURE__*/ React.createElement(TotalPhaseSummary, {
        label: "Total",
        hours: totalHours,
        noFraction: true,
        cost: totalCost / 100
    }), /*#__PURE__*/ React.createElement("br", null), itemGroups.map(function(group, groupIndex) {
        var totalHours = group.itemRows.reduce(function(acc, itemRow) {
            var ref;
            var itemRowCount = (ref = calculateItemRowHours(itemRow)) !== null && ref !== void 0 ? ref : 0;
            return acc += itemRowCount;
        }, 0);
        return group.itemRows.map(function(itemRow, rowIndex) {
            return /*#__PURE__*/ React.createElement(PhaseSummary, {
                key: "".concat(groupIndex, ":").concat(rowIndex),
                label: "Phase ".concat(groupIndex + 1, " - ").concat(itemRow.item.name),
                parentHours: totalHours,
                hours: calculateItemRowHours(itemRow),
                cost: allCosts[groupIndex][rowIndex] / 100
            }, /*#__PURE__*/ React.createElement(PhaseListContainer, null, uniq(_toConsumableArray(itemRow.allPhases)).map(function(phase, phaseIndex) {
                return /*#__PURE__*/ React.createElement("div", {
                    key: phaseIndex,
                    ref: function(dom) {
                        if (dom) {
                            var specs = {
                                top: getElementWindowTop(dom),
                                height: dom.offsetHeight
                            };
                            setIn(phaseLabelPositionsRef.current, [
                                groupIndex,
                                rowIndex,
                                phaseIndex
                            ], specs);
                        }
                    },
                    children: phase
                });
            })));
        });
    }))), /*#__PURE__*/ React.createElement(Col, {
        xs: true
    }, /*#__PURE__*/ React.createElement(ChartSection, {
        itemGroups: itemGroups,
        phaseLabelPositions: phaseLabelPositionsRef.current
    })))))), additionalComponents);
}
var GanttView = withContext(_GanttView, {
    mapProps: function(context) {
        return {
            cart: context.state.cart,
            phasesConfig: context.state.phasesConfig,
            selectedRegion: context.state.selectedRegion
        };
    }
});
export default GanttView;
